import { useState, useCallback } from "react";
import { STORAGE_KEYS } from "../constants";

export const useLocalStorage = (key, initialValue) => {
  // Get from local storage then parse stored json or return initialValue
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      return initialValue;
    }
  });

  // Stable across renders so consumers can safely put `setValue` in useEffect deps.
  // Uses functional setState so we don't have to close over `storedValue` (which would
  // re-create the callback on every state change and re-introduce the unstable-identity bug).
  const setValue = useCallback((value) => {
    setStoredValue((prev) => {
      const valueToStore = value instanceof Function ? value(prev) : value;
      try {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      } catch (error) {
        console.error(`Error setting localStorage key "${key}":`, error);
      }
      return valueToStore;
    });
  }, [key]);

  return [storedValue, setValue];
};

export const useQuizSelections = () => {
  return useLocalStorage(STORAGE_KEYS.AI_GIRLFRIEND_SELECTIONS, {});
};

export const useTrackingParams = () => {
  return useLocalStorage(STORAGE_KEYS.TRACKING_PARAMS, {});
};
